const { InspectorControls } = wp.blockEditor;
const { createHigherOrderComponent } = wp.compose;
const { PanelBody, SelectControl, TextControl } = wp.components;
const { Fragment } = wp.element;
const { addFilter } = wp.hooks;
const { __ } = wp.i18n;

const sitemapBlocks = new Set([
	'wpgoplugins/simple-sitemap-block',
	'wpgoplugins/simple-sitemap-group-block',
	'wpgoplugins/simple-sitemap-child-pages-block',
	'wpgoplugins/simple-sitemap-taxonomy-terms-block',
	'wpgoplugins/simple-sitemap-navigation-menu-block',
	'wpgoplugins/simple-sitemap-archive-links-block',
	'wpgoplugins/simple-sitemap-product-block',
]);

const withSitemapSpacingControls = createHigherOrderComponent(
	(BlockEdit) =>
		function SitemapSpacingControls(props) {
			if (!sitemapBlocks.has(props.name)) {
				return <BlockEdit {...props} />;
			}

			const { attributes, setAttributes } = props;
			const spacingPreset = attributes.spacing_preset || 'inherit';

			return (
				<Fragment>
					<BlockEdit {...props} />
					<InspectorControls>
						<PanelBody
							title={__('Sitemap Spacing', 'simple-sitemap')}
							initialOpen={false}
						>
							<SelectControl
								label={__('Spacing preset', 'simple-sitemap')}
								help={__(
									'Inherit uses the global Simple Sitemap setting.',
									'simple-sitemap'
								)}
								value={spacingPreset}
								options={[
									{
										label: __(
											'Inherit global setting',
											'simple-sitemap'
										),
										value: 'inherit',
									},
									{
										label: __('Compact', 'simple-sitemap'),
										value: 'compact',
									},
									{
										label: __(
											'Comfortable',
											'simple-sitemap'
										),
										value: 'comfortable',
									},
									{
										label: __('Custom', 'simple-sitemap'),
										value: 'custom',
									},
								]}
								onChange={(value) =>
									setAttributes({ spacing_preset: value })
								}
							/>
							{spacingPreset === 'custom' && (
								<Fragment>
									<TextControl
										label={__(
											'Item spacing',
											'simple-sitemap'
										)}
										help={__(
											'Vertical space around each item, for example 0.2em or 4px.',
											'simple-sitemap'
										)}
										value={attributes.item_spacing || ''}
										onChange={(value) =>
											setAttributes({
												item_spacing: value,
											})
										}
									/>
									<TextControl
										label={__(
											'Nested level spacing',
											'simple-sitemap'
										)}
										help={__(
											'Space before and after nested lists, for example 0.3em 0.5em.',
											'simple-sitemap'
										)}
										value={attributes.nested_spacing || ''}
										onChange={(value) =>
											setAttributes({
												nested_spacing: value,
											})
										}
									/>
								</Fragment>
							)}
						</PanelBody>
					</InspectorControls>
				</Fragment>
			);
		},
	'withSitemapSpacingControls'
);

addFilter(
	'editor.BlockEdit',
	'simple-sitemap/spacing-controls',
	withSitemapSpacingControls
);
